export default {
  data() {
    return {
      _scrollPosition: 0, // 记录每个绑定的元素的滚动位置
      _scrollElementSelector: '',
    };
  },
  activated() {
    if (this._scrollElementSelector) {
      this.$nextTick(() => {
        const top = this._scrollPosition
        let warp = document.querySelector(this._scrollElementSelector)
        if (warp && warp.scrollTo) {
          warp.scrollTo(0, top || 0);
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this._scrollElementSelector) {
      this._scrollPosition = document.querySelector(this._scrollElementSelector)?.scrollTop || 0
    }
    next()
  },
  beforeRouteUpdate(to, from, next) {
    if (this._scrollElementSelector) {
      this._scrollPosition = document.querySelector(this._scrollElementSelector)?.scrollTop || 0
    }
    next();
  },
};